import React from 'react';
import { notification } from 'antd';
const Secret = () => {
  const openNotification = (placement: any) => {
    notification.info({
      message: 'Настяяяяяяяяяяяяя',
      description: 'Настя ты просто пушка =)(=',
      placement,
    });
  };
  const puska = () => {
    openNotification('bottomRight');
    openNotification('bottom');
    openNotification('bottomLeft');
    openNotification('top');
    openNotification('topLeft');
    openNotification('topRight');
  };
  return (
    <>
      <button
        // onClick={puska}
        style={{ width: 'fit-content', height: 'fit-content' }}
        className="button__secret"
      >
        <img src="http://194.61.0.136/media/exit.png" alt="" style={{ width: 100 }} />
      </button>
    </>
  );
};

export default Secret;
